export default "__VITE_PUBLIC_ASSET__90504db8__"